import { useEffect, useState } from "react";
import MemePopup from "../components/MemeGenerator/MemePopup";
import MemeEditor from "../components/MemeGenerator/MemeEditor";

import generalMeme from "./../images/new/meme/generalMeme.png";
import penguinMeme from "./../images/new/meme/penguinMeme.png";
import template1 from "./../images/new/meme/template1.png";
import template2 from "./../images/new/meme/template2.png";
import template3 from "./../images/new/meme/template3.png";
import template4 from "./../images/new/meme/template4.png";
import template5 from "./../images/new/meme/template5.png";
import pudgy1 from "./../images/new/meme/pudgy1.png";
import pudgy2 from "./../images/new/meme/pudgy2.png";
import pudgy3 from "./../images/new/meme/pudgy3.png";
import pudgy4 from "./../images/new/meme/pudgy4.png";
function MemeCreator() {
  const [memePopup, setMemePopup] = useState(false);
  const [editorPopup, setEditorPopup] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const memeType = [
    {
      id: 1,
      key: "General",
      title: "General Memes",
      description:
        "We will show you general memes from the Healing Hippie Library",
      image: generalMeme,
    },
    {
      id: 2,
      key: "Pudgy",
      title: "Pudgy Penguins",
      description:
        "We will show you Pudgy Penguins memes from the Healing Hippie Library",
      image: penguinMeme,
    },
  ];

  const templateData = {
    key: "General",
    data: [
      {
        id: 1,
        name: "Drake Hotline Bling",
        image: template1,
      },
      {
        id: 2,
        name: "Distracted Boyfriend",
        image: template2,
      },
      {
        id: 3,
        name: "Two Buttons",
        image: template3,
      },
      {
        id: 4,
        name: "Exit 12",
        image: template4,
      },
      {
        id: 5,
        name: "Donal Duck Waking Up",
        image: template5,
      },
    ],
  };

  const pudgyData = {
    key: "Pudgy",
    data: [
      {
        id: 1,
        name: "Pudgy Penguin 1",
        image: pudgy1,
      },
      {
        id: 2,
        name: "Pudgy Penguin 2",
        image: pudgy2,
      },
      {
        id: 3,
        name: "Pudgy Penguin 3",
        image: pudgy3,
      },
      {
        id: 4,
        name: "Pudgy Penguin 4",
        image: pudgy4,
      },
    ],
  };

  const searchType = [
    {
      id: 1,
      key: "pexel",
      title: "Pexel",
    },
    {
      id: 2,
      key: "unsplash",
      title: "Unsplash",
    },
  ];

  const stickers = [
    {
      id: 1,
      key: "Body",
      data: [
        {
          id: 1,
          name: "Body 1",
          image: pudgy1,
        },
        {
          id: 2,
          name: "Body 2",
          image: pudgy2,
        },
        {
          id: 3,
          name: "Body 3",
          image: pudgy3,
        },
      ],
    },
    {
      id: 1,
      key: "Eyes",
      data: [
        {
          id: 1,
          name: "Body 1",
          image: pudgy3,
        },
        {
          id: 2,
          name: "Body 2",
          image: pudgy4,
        },
        {
          id: 3,
          name: "Body 3",
          image: pudgy1,
        },
      ],
    },
  ];

  const fontFamilies = [
    {
      id: 1,
      title: "Poppins",
    },
    {
      id: 2,
      title: "Abril Fatface",
    },
    {
      id: 3,
      title: "Barlow",
    },
  ];

  const fontWeights = [
    {
      id: 1,
      key: "Thin",
      title: "100",
    },
    {
      id: 2,
      key: "Normal",
      title: "400",
    },
    {
      id: 3,
      key: "Bold",
      title: "700",
    },
    {
      id: 4,
      key: "Heavy",
      title: "900",
    },
  ];

  const cameraTypeList = [
    { id: 1, title: "Default" },
    { id: 2, title: "HP true Vision HD Camera" },
  ];
  useEffect(()=>{
    if(selectedTemplate)
      { 
        setMemePopup(false)
        setEditorPopup(true)
      }
    else if(selectedTemplate!=null)
    {
      setEditorPopup(false)
      setMemePopup(true)
    }
  },[selectedTemplate])

  return (
    <>
      <section id="memeSection">
        <div className="wrapper">
          <div className="memeTextContent">
            <h2 className="sectionTitle">Meme Creator</h2>
            <p>
              Our meme generator makes it easy to create your own custom memes.
            </p>
            <button
              className="customButton primaryButton"
              onClick={() => {
                setEditorPopup(false);
                setMemePopup(true);
              }}
            >
              Create Meme
            </button>
          </div>
        </div>
      </section>
      {memePopup && (
        <MemePopup
          onHide={setMemePopup}
          next={setMemePopup}
          memeType={memeType}
          list={[templateData]}
          selectedTemplate={selectedTemplate}
          setSelectedTemplate={setSelectedTemplate}
          searchType={searchType}
          cameraTypeList={cameraTypeList}
          setEditorPopup = {setEditorPopup}
        />
      )}
      {editorPopup &&(
        <MemeEditor
          onHide={
            ()=>{
              setSelectedTemplate(false)
            }
          }
          selectedTemplate={selectedTemplate}
          stickers={stickers}
          fontFamilies={fontFamilies}
          fontWeights={fontWeights}
        />
      )}
    </>
  );
}

export default MemeCreator;
